import type { FaireProductEntity } from "../../entity_types/product";

export const p_ybd4z335th: FaireProductEntity = {
  token: "p_ybd4z335th",
  type: "product",
  name: "LM-SK-1000 BUBBLE SKIRT - BUBBLEGUM",
  brandToken: "b_h6l667zq",
  brandName: "Girlie Girl Originals",
  imageUrl: "https://cdn.faire.com/fastly/58924ad1697d262fe7e05727fec20a1a89cd06731c056ba54a4936a3c87d1aa1.jpeg",
  galleryImageUrls: [],
  priceDollars: 18.5,
  description: "This Bubble Skirt from Girlie Girl Originals adds volume and movement with a bubble shape that coordinates easily with tees, blouses, or layered pieces. Made for a bold, fun look, it pairs well with casual or dressed-up tops and reflects the brand’s spirited, southern-inspired aesthetic.",
  tags: [],
  msrpDollars: 37,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-28T21:01:33.613Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
